import { useSignIn, useSignUp, useUser } from "@clerk/clerk-react";
import CustomTabs from "Components/CustomTabs/CustomTabs";
import PopUp from "Components/PopUp/PopUp";
import TextInput from "Components/TextInput/TextInput";
import { Button } from "Components/ui/button";
import { AnimatePresence, motion } from "framer-motion";
import UseInnerWidth from "hooks/UseInnerWidth";
import SignUp from "Pages/SignUp/SignUp";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import AuthLayout from "../../Components/AuthLayout/AuthLayout";
import { checkUser } from "../../Redux/Profile/ProfileActions";
import ForgetPassword from "./ForgetPassword/ForgetPassword";

function Login({ welcome }) {
  const { signIn } = useSignIn();
  const { isSignedIn } = useUser();
  const { isLoaded, signUp } = useSignUp();

  const [openWelcome, setOpenWelcome] = useState(false);

  const dispatch = useDispatch();
  const { checkUserLoading, checkUserError } = useSelector(
    (state) => state.ProfileReducer
  );

  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Store current theme to restore it later
    const previousTheme = document.documentElement.getAttribute("data-theme");

    // Force dark theme
    document.documentElement.setAttribute("data-theme", "dark");

    return () => {
      // Restore previous theme when leaving this page
      if (previousTheme) {
        document.documentElement.setAttribute("data-theme", previousTheme);
      } else {
        document.documentElement.removeAttribute("data-theme");
      }
    };
  }, []);

  useEffect(() => {
    if (welcome) {
      setOpenWelcome(true);
    }
  }, [welcome]);
  const clerkLogin = async () => {
    try {
      setLoading(true);
      setError(null);
      const signedIn = await signIn.create({
        identifier: data.email,
        password: data.password,
        strategy: "password",
      
      });

      setLoading(false);
      if (
        signIn?.status == "missing_requirements" &&
        signIn?.unverifiedFields?.includes("email_address")
      ) {
        await signUp.prepareEmailAddressVerification({
          strategy: "email_code",
        });
        navigate("/auth/OtpVerification?email=" + data.email);
      } else window.location.href = "/";
    } catch (e) {
      setLoading(false);
      setError(e);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(checkUser(data.email, clerkLogin));
  };

  const navigate = useNavigate();
  const [data, setData] = useState({});

  useEffect(() => {
    if (isSignedIn && isLoaded) {
      navigate("/");
    }
  }, [isSignedIn, isLoaded]);

  const width = UseInnerWidth();

  useEffect(() => {
    if (error) {
      toast.error(error.message, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
    }
    if (checkUserError) {
      toast.error(checkUserError, {
        autoClose: 2000,
        className: "bg-red-opacity text-red",
      });
    }
  }, [error, checkUserError]);

  const [selectedTab, setSelectedTab] = useState("Login");

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    setSearchParams({ tab: selectedTab });
  }, [selectedTab]);

  useEffect(() => {
    if (searchParams.get("tab")) {
      setSelectedTab(searchParams.get("tab"));
    }
  }, []);

  return (
    <AuthLayout>
      <div className="flex-1 px-8 flex w-full justify-center mt-[43vh] translate-y-[-50%] h-[60vh]">
        <div className="w-full  max-w-[30rem]">
          <CustomTabs
            tabs={[
              { label: "Login", value: "Login" },
              { label: "Register", value: "Register" },
            ]}
            activeTab={selectedTab}
            setActiveTab={setSelectedTab}
          />
          <div
            className="overflow-auto h-[60vh]"
            style={{
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <AnimatePresence mode="wait">
              {selectedTab === "Login" ? (
                searchParams.get("tab") == "forgetEmail" ? (
                  <ForgetPassword />
                ) : (
                  <motion.form
                    key="loginForm"
                    className="flex flex-col gap-6 w-full overflow-hidden"
                    onSubmit={(e) => handleSubmit(e)}
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                  >
                    <TextInput
                      label="Email"
                      required={true}
                      placeholder="Enter your email"
                      type="email"
                      value={data.email}
                      onChange={(e) =>
                        setData({ ...data, email: e.target.value })
                      }
                    />
                    <TextInput
                      required={true}
                      label="Password"
                      placeholder="Enter your password"
                      type="password"
                      value={data.password}
                      onChange={(e) =>
                        setData({ ...data, password: e.target.value })
                      }
                    />
                    {/* <div
                    className="w-fit ml-auto text-grey text-sm mt-[-1rem]  hover:underline cursor-pointer"
                    onClick={() => navigate("/auth/loginLink")}
                  >
                    Use link instead
                  </div> */}
                    <div
                      className="w-fit ml-auto text-grey text-sm mt-[-1rem]  hover:underline cursor-pointer"
                      onClick={() =>
                        setSearchParams({
                          tab: "forgetEmail",
                        })
                      }
                    >
                      Reset Password
                    </div>

                    <Button
                      type="submit"
                      className="p-[1.3rem]"
                      disabled={!isLoaded || loading || checkUserLoading}
                    >
                      {loading || checkUserLoading ? "Logging In" : "Login"}
                    </Button>
                  </motion.form>
                )
              ) : (
                <motion.div
                  className="overflow-hidden"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                >
                  <SignUp key="signUpForm" />
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
      {openWelcome && (
        <PopUp
          open={openWelcome}
          setOpen={setOpenWelcome}
          width="30vw"
          title="Welcome to Only Funds!"
        >
          <div className="flex flex-col gap-4 w-full">
            <p className="text-base text-white mt-2">
              Welcome To Only Funds! <br /> Check your email for the login
              credentials!
            </p>
            <Button onClick={() => setOpenWelcome(false)} className="w-full">
              Continue
            </Button>
          </div>
        </PopUp>
      )}
    </AuthLayout>
  );
}

export default Login;
